<button (click)="close('Pressed close button')" class="modal-close"></button>

<h4 class="modal-title" *ngIf="data.title">{{ data.title }}</h4>

<div class="modal-content">
  <p class="modal-intro">
    {{ data.message }}
  </p>
</div>

<div class="modal-footer">
  <button
    (click)="close('Pressed OK button')"
    class="o-button o-button--default"
    i18n="Button|Ok Button @@buttonOk"
  >
    OK
  </button>
</div>
